const isAmpRecette = (bind: string) =>
    ['amp_recette', 'amp-recette'].includes(bind);

export const isAmp = (bind: string) =>
    bind === 'ampmetropole' || isAmpRecette(bind);
